export const customerNo = localStorage.getItem('customerNo');
export const role = localStorage.getItem('role');
export const defaultBillValues = [1165, 1166].includes(Number(customerNo));
export const UPLDefaultBillValues = [1166].includes(Number(customerNo));
export const enableQuicksightDashboard = [1330,1375].includes(Number(customerNo));

export const ENV = process.env.REACT_APP_BASE_URL.split('//')?.[1]?.substring(0,3)?.toUpperCase() || "DEV";

export const mastersExportDisabled = ()=>{
    switch(customerNo.toString()){
        case '1545':
         return ["ADMINISTRATOR", "ELIXIR"].includes(role?.toString().toUpperCase()) ? false : true;
        default : 
         return false;
    }
}

export const FEATURES = {
    enableCoverLetterPdf: [1158].includes(Number(customerNo)),
    isThirdPartyPoReferenceNumberNeededInBillApproval: [1166].includes(Number(customerNo)),
    profitCentreForNonMIRO : [1166].includes(Number(customerNo)),
    isInternalFreightMISReportEnabled : [1330].includes(Number(customerNo)) && role && ["ELIXIR"].includes(role.toString().toUpperCase()),
    isNegativeRateAllowedForPsLineItem: (psLineItemId) => {
        
        switch (ENV) {
            case "DEV":
                return [2014].includes(Number(psLineItemId));
            case "QA":
                return [861].includes(Number(psLineItemId));
            case "UAT":
                return [1021].includes(Number(psLineItemId));
            default:
                return [4942].includes(Number(psLineItemId));
        }
    },
    flutterOEEnabled : [1654].includes(Number(customerNo)),
    mastersExportDisabled
}

export const ASIDEDROPDOWN_CONSTANTS = {
    reports : {
        title : "Reports",
        INTERNAL_FREIGHT_MIS_REPORT: 'Internal Freight MIS'
    }
}